(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["equibowl-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const updatePhoto = select => {
    const section = select.closest('[data-eq-product-photos]');
    const photo = section?.querySelector('[data-eq-product-photo]');
    if (!photo) return;
    const template = Array.from(photo.querySelectorAll('template[data-eq-product-photo-variant]')).find(node => node.dataset.eqProductPhotoVariant === select.value);
    if (!template) return;
    photo.querySelector('img')?.remove();
    photo.append(template.content.cloneNode(true));
  };
  const syncPhotos = root => root.querySelectorAll('[data-eq-product-photos] [data-eq-variant-select]').forEach(updatePhoto);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-eq-variant-select]')) updatePhoto(event.target);
  });
  document.addEventListener('shopify:section:load', event => syncPhotos(event.target));
  window.addEventListener('pageshow', () => syncPhotos(document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => syncPhotos(document), { once: true });
  else syncPhotos(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
